<!-- <div class="row m-0 text-center bg-blue-200">
    <div class="col-md-12 color-white pt-2 pb-2">
        © 2024
    </div>
</div> -->

<footer class="bg-gray-800 py-2">
    <div class="container mx-auto text-center text-gray-300">
      <p>&copy; 2024 Techo2. All rights reserved.</p>
    </div>
</footer>